'use client';
import {cn} from '@/lib/utils';
import parse from 'html-react-parser';
import {useSearchParams} from 'next/navigation';
import {useEffect, useState} from 'react';
export default function HtmlTab(Prop: {moduleSlug: string; moduleOption: any}) {
  const {moduleOption, moduleSlug} = Prop;
  const [isLoading, setIsLoading] = useState(true);
  const searchParams = useSearchParams();
  const items: {slug: string; title: string; html: string}[] =
    moduleOption?.items || [];

  const defaultTab = moduleOption?.defaultTab || items?.[0]?.slug || '';
  const [selectedTab, setSelectedTab] = useState(
    searchParams.get('t') &&
      items.find((item) => item.slug === searchParams.get('t'))
      ? searchParams.get('t')
      : defaultTab
  );

  useEffect(() => {
    if (selectedTab) {
      const url = new URL(window.location.href);
      url.searchParams.set('t', selectedTab);
      url.hash = window.location.hash;
      window.history.pushState({}, '', url.href);
    }
    Array.from(document.getElementsByClassName('tab-' + moduleSlug)).map(
      (el) => {
        el.classList.contains(selectedTab)
          ? el.classList.remove('hidden')
          : el.classList.add('hidden');
      }
    );
    setIsLoading(false);
  }, [selectedTab]);

  return (
    <div>
      <div className="flex items-center justify-center space-x-0">
        {items.map((content: any, index: number) => {
          return (
            <button
              key={content.slug}
              className={cn('text-center hover:text-[#E12726]')}
            >
              <div
                className={cn(
                  'text-center px-10 ',
                  index > 0 && 'border-l-[1px] border-[#363636]',
                  selectedTab === content.slug && 'text-[#E12726] font-[700]'
                )}
                id={content.slug}
                onClick={() => setSelectedTab(content.slug)}
              >
                {content.title}
              </div>
              <div
                className={cn(
                  'mx-8 h-[4px] rounded-t-md',
                  selectedTab === content.slug && 'bg-[#E12726]'
                )}
              ></div>
            </button>
          );
        })}
      </div>
      {isLoading && (
        <div className="flex items-center justify-center my-5">
          <span className="material-symbols thin animate-spin text-[100px] text-[#eee]">
            progress_activity
          </span>
        </div>
      )}

      {parse(
        items.find((content: any) => content.slug === selectedTab)?.html ?? ''
      )}
    </div>
  );
}
